import { render, staticRenderFns } from "./OrderRichTextInput.vue?vue&type=template&id=4e79eff4&"
import script from "./OrderRichTextInput.vue?vue&type=script&lang=js&"
export * from "./OrderRichTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports